module.exports = __webpack_public_path__ + "img/result-detail-communication-inright01.036f708a.svg";